import { render, staticRenderFns } from "./Proficiency.vue?vue&type=template&id=35369e02"
import script from "./Proficiency.vue?vue&type=script&lang=js"
export * from "./Proficiency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports